export enum FormModes {
	PATCH = 'PATCH',
	POST = 'POST'
}
